import {
    FORMAL_OFFER_VARIATION_TYPES,
    TFormalOfferVariationType
} from './formalOffers.types';

/**
 * Performs runtime type checking on formal offer variation types.
 * Since the API returns formal offer variation types as strings,
 * it's handy to be able to check at runtime whether the variation type
 * it's returned is one of the ones we know how to handle
 */
export function isFormalOfferVariationType(
    x: string
): x is TFormalOfferVariationType {
    return (FORMAL_OFFER_VARIATION_TYPES as readonly string[]).includes(x);
}
